import { Injectable, inject } from '@angular/core';

import { STORAGE_KEY } from '../constants/storage.constants';
import { LocalStorageService } from './local-storage.service';

const AUTH_PATHS: readonly string[] = ['/', '/auth', '/reactivate', '/security-alert'];

@Injectable({ providedIn: 'root' })
export class ReturnUrlService {
  private readonly storage = inject(LocalStorageService);

  public remember(url: string): void {
    if (!ReturnUrlService.isReturnable(url)) {
      return;
    }
    this.storage.setItem(STORAGE_KEY.returnUrl, url);
  }

  public consume(): string | null {
    const url = this.storage.getItem<string>(STORAGE_KEY.returnUrl);

    this.storage.removeItem(STORAGE_KEY.returnUrl);

    return url && ReturnUrlService.isReturnable(url) ? url : null;
  }

  private static isReturnable(url: unknown): url is string {
    if (typeof url !== 'string') {
      return false;
    }
    if (!url.startsWith('/') || url.startsWith('//') || url.includes('\\')) {
      return false;
    }
    const path = url.split('?')[0];

    return !AUTH_PATHS.some(
      (authPath) => path === authPath || path.startsWith(`${authPath}/`),
    );
  }
}
